import { apiClient } from './client';

// One Send-to-Claude repo mapping row: where a dispatch agent (a developer's
// machine, by name) opens tickets for one product line. A null productLineId
// is that agent's default repo. Managed in Settings → Claude Dispatch.
export interface DispatchRepoMapping {
  id: string;
  agentName: string;
  productLineId: string | null;
  productLineName: string | null;
  repoPath: string;
  updatedAt: string;
}

export interface DispatchRepoData {
  mappings: DispatchRepoMapping[];
  // Each agent's self-reported folder inventory (repo folders that exist on
  // its machine), backing the settings folder picker. Absent for agents that
  // haven't reported yet.
  agentRepos: Record<string, string[]>;
}

export const aiDispatchReposApi = {
  list: async (): Promise<DispatchRepoData> => {
    const res = await apiClient.get('/ai-dispatch-repos');
    return res.data.data as DispatchRepoData;
  },

  /** Replace one agent's whole mapping set in one shot. */
  save: async (
    agentName: string,
    data: { defaultRepo: string | null; repos: { productLineId: string; repoPath: string }[] },
  ): Promise<DispatchRepoMapping[]> => {
    const res = await apiClient.put(`/ai-dispatch-repos/${encodeURIComponent(agentName)}`, data);
    return res.data.data.mappings as DispatchRepoMapping[];
  },

  remove: async (agentName: string): Promise<void> => {
    await apiClient.delete(`/ai-dispatch-repos/${encodeURIComponent(agentName)}`);
  },
};
